<template>
  <div class="event-card-skeleton">
    <div class="event-card-skeleton__image skeleton-shimmer"></div>

    <div class="event-card-skeleton__content">
      <div class="event-card-skeleton__content-date skeleton-shimmer"></div>
      <div class="event-card-skeleton__content-title skeleton-shimmer"></div>
      <div class="event-card-skeleton__content-text skeleton-shimmer"></div>
      <div
        class="event-card-skeleton__content-text skeleton-shimmer short"
      ></div>
      <div class="event-card-skeleton__content-btn skeleton-shimmer"></div>
    </div>

    <div class="event-calendar-skeleton">
      <div class="event-calendar-skeleton__title skeleton-shimmer"></div>

      <div class="event-calendar-skeleton__list">
        <div v-for="n in 4" :key="n" class="event-calendar-skeleton__list-item">
          <div
            class="event-calendar-skeleton__list-marker skeleton-shimmer"
          ></div>
          <div
            class="event-calendar-skeleton__list-text skeleton-shimmer"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventCardSkeleton"
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.skeleton-shimmer {
  @include skeleton-shimmer();
}

.event-card-skeleton {
  display: flex;
  border-radius: 2px;
  border: 1px solid var(--gray-darker);
  background-color: #ffffff;
  width: 100%;
  margin-bottom: 22px;
  position: relative;

  &__image {
    width: 112px;
    height: 112px;
    margin: 30px;
    flex-shrink: 0;
    align-self: flex-start;

    @include respond-down(lg) {
      width: 80px;
      height: 40px;
      margin-top: 32px;
    }

    @include respond-down(md) {
      width: 48px;
      height: 28px;
      margin: 15px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 387px;
    max-width: 711px;
    padding: 30px 30px 30px 0;
    flex: 1;

    @include respond-down(lg) {
      min-width: 290px;
      margin-right: 0;
      box-sizing: border-box;
      padding-right: 30px;
    }

    @include respond-down(md) {
      padding: 15px 15px 15px 0;
      min-width: 184px;
    }

    &-date {
      width: 200px;
      height: 16px;
      margin-bottom: 14px;

      @include respond-down(md) {
        width: 150px;
        height: 14px;
        margin-bottom: 8px;
      }
    }

    &-title {
      width: 300px;
      height: 24px;
      margin-bottom: 16px;

      @include respond-down(md) {
        width: 200px;
        height: 20px;
        margin-bottom: 8px;
      }
    }

    &-text {
      width: 400px;
      height: 16px;
      margin-bottom: 8px;

      &.short {
        width: 250px;
        margin-bottom: 30px;
      }

      @include respond-down(md) {
        width: 180px;
        height: 14px;

        &.short {
          width: 120px;
          margin-bottom: 24px;
        }
      }
    }

    &-btn {
      width: 120px;
      height: 40px;
      margin-top: auto;
    }
  }
}

.event-calendar-skeleton {
  @include respond-down(md) {
    display: none;
  }

  border-left: 1px solid var(--gray-darker);
  padding: 30px;
  width: 351px;
  flex-shrink: 0;
  box-sizing: border-box;

  @include respond-down(lg) {
    width: 300px;
    padding: 30px;
  }

  &__title {
    width: 200px;
    height: 20px;
    margin-bottom: 24px;
  }

  &__list {
    &-item {
      display: flex;
      align-items: center;
      margin-bottom: 19px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &-marker {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      flex-shrink: 0;
      margin-right: 16.2px;
    }

    &-text {
      width: 180px;
      height: 16px;
    }
  }
}
</style>
